import { dateFormat, formatDateTime } from "../../../../../utils/dateFormat";

export const requestorDetails = (object) => {
  const {
    firstName: requestorFirstName,
    middleName: requestorMiddleName,
    lastName: requestorLastName,
    affiliate,
    branch,
    username,
    createdAt,
  } = object.requestor || {};

  return [
    {
      label: "Requested By",
      value: `${requestorFirstName} ${
        requestorMiddleName || ""
      } ${requestorLastName}  (${username})`,
    },
    {
      label: "Requested Date",
      value: formatDateTime(object?.requestedDate ?? object?.createdAt),
    },
    {
      label: "Affiliate",
      value: affiliate?.code || affiliate?.id || "",
    },
    {
      label: "Branch",
      value: branch?.code || branch?.id || "",
    },
    {
      label: "Reason for Unlocking",
      value: object.reason,
    },
    {
      label: "Remarks",
      value: object.remarks,
    },
  ];
};
